import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faArrowRight, faSpinner, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Sidebar from '../Sidebar/Sidebar';
import axios from 'axios';
import { buildApiUrl } from '../../config/api.config';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [verifying, setVerifying] = React.useState(true);
  const [error, setError] = React.useState(null);

  useEffect(() => {
    const verifyPayment = async () => {
      const searchParams = new URLSearchParams(location.search);
      const sessionId = searchParams.get('session_id');
      
      if (sessionId) {
        try {
          setVerifying(true);
          console.log("🔄 Verifying manual fulfillment for session:", sessionId);
          const res = await axios.get(buildApiUrl(`stripe/verify-session/${sessionId}`));
          if (res.data.success) {
            console.log("✅ Fulfillment success!");
            setVerifying(false);
          } else {
            setError({
                message: res.data.message || "Fulfillment failed",
                detail: res.data.detail
            });
            setVerifying(false);
          }
        } catch (error) {
          console.error("Manual verification failed:", error);
          setError({
              message: "Connection failed. Please check your internet or try again.",
              detail: error.message
          });
          setVerifying(false);
        }
      } else {
        setVerifying(false);
      }
    };

    verifyPayment();
  }, [location]);

  return (
    <div className="admin-layout" style={{ background: '#101113', height: '100vh', display: 'flex', overflow: 'hidden' }}>
      <Sidebar />
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#101113' }}>
        <div style={{ 
          maxWidth: '500px', 
          width: '90%', 
          padding: '3rem', 
          background: 'rgba(255, 255, 255, 0.02)', 
          borderRadius: '32px', 
          border: '1px solid rgba(255, 255, 255, 0.05)', 
          textAlign: 'center',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
        }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            background: error ? 'rgba(255, 65, 53, 0.1)' : (verifying ? 'rgba(88, 101, 242, 0.1)' : 'rgba(0, 209, 178, 0.1)'), 
            color: error ? '#ff4135' : (verifying ? '#5865f2' : '#00d1b2'), 
            borderRadius: '24px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            fontSize: '2.5rem', 
            margin: '0 auto 2rem' 
          }}>
            {verifying ? <FontAwesomeIcon icon={faSpinner} spin /> : (error ? <FontAwesomeIcon icon={faCircleInfo} /> : <FontAwesomeIcon icon={faCircleCheck} />)}
          </div>
          <h1 style={{ color: 'white', fontSize: '2rem', fontWeight: '800', marginBottom: '1rem' }}>
            {verifying ? 'Verifying Payment...' : (error ? 'Sync Issues Detected' : 'Payment Successful!')}
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.4)', lineHeight: '1.6', marginBottom: '2.5rem' }}>
            {verifying ? 'Please wait while we sync your subscription data with our servers...' : 
             (error ? `Your payment was accepted but we're having trouble updating your account: ${error.message}` : 
             'Your restaurant subscription has been renewed successfully. Your license has been extended automatically.')}
          </p>

          {error && error.detail && (
            <div style={{ 
                background: 'rgba(0,0,0,0.3)', 
                padding: '1rem', 
                borderRadius: '12px', 
                fontSize: '0.7rem', 
                color: 'rgba(255, 65, 53, 0.7)', 
                fontFamily: 'monospace',
                textAlign: 'left',
                marginBottom: '2rem',
                maxHeight: '150px',
                overflowY: 'auto',
                border: '1px solid rgba(255, 65, 53, 0.1)'
            }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Trace Output:</div>
                {error.detail}
            </div>
          )}

          <button 
            disabled={verifying}
            onClick={() => navigate('/admin/settings')}
            style={{ 
              width: '100%', 
              padding: '1.2rem', 
              background: 'var(--tf-primary)', 
              color: 'white', 
              border: 'none', 
              borderRadius: '16px', 
              fontWeight: '800', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.8rem'
            }}
          >
            Back to Dashboard <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>
      </main>
    </div>
  );
};

export default SubscriptionSuccess;
